<div *ngIf="finished==false" class='text-center'>
  <svg width="40px" height="40px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-rolling"
    style="background: none;">
    <circle cx="50" cy="50" fill="none" stroke="#28a745" stroke-width="7" r="35"
      stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(346.659 50 50)">
      <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50"
        keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform>
    </circle>
  </svg>
</div>

<div *ngIf="no_recfound" class="text-center">
  {{mls?.languageText?.webinar?.key1}}<span *ngIf="mls?.is_lskey_display==1">(webinar.key1)</span>
</div>

<div *ngIf="is_res_received && no_recfound==false" class="bg-white rounded overflow-hidden mt-2 cursor-pointer"
  (click)="navigateto()"
  [eventTracker]='{"category":"web_share","action":"click_on_webinar","product_type":product_type,"product_id":product_type_id}'>
  <img class="w-100 doctlk-dtls-top-img post-pic" src={{webinar_detail?.banner}}
    onerror="this.src='assets/img/image_placeholder.svg'" />
  <div class=" w-100 p-3  fnt-size14px ">
    <div>
      <p class="fnt-size18px mb-2"><b>{{webinar_detail?.title}}</b></p>
      <p class="fnt-size14px mb-2 light-font">

      <div *ngIf="webinar_detail?.channel?.pharma_classification!='pharma'">
        <p class="userPostText " style="display:inline;">{{webinar_detail?.description}}</p>
      </div>


      <div *ngIf="webinar_detail?.channel?.pharma_classification=='pharma'">
          <h3 class=" text-center mt-4">{{mls?.languageText?.webinar?.key2}}</h3>
      </div>


      <p *ngIf="webinar_detail?.channel?.pharma_classification!='pharma'" class="fnt-size12px mb-2">
        {{mls?.languageText?.webinar?.key3}}<span *ngIf="mls?.is_lskey_display==1">(webinar.key3)</span></p>
      <div *ngIf="webinar_detail?.channel?.pharma_classification!='pharma'" class="row m-0">


        <div class="float-left col-8 p-0 fnt-size14px" *ngFor="let speaker of webinar_detail?.speaker">
          <div class="float-left mr-2 col-2 p-0" style="min-width: 40px; max-width: 40px;">
            <img class="post-pic user-40 rounded-circle" onerror="this.src='assets/img/user_placeholder.svg'"
              src={{speaker?.profile_pic}}>
          </div>
          <p class="font-weight-bold">{{speaker?.name}}</p>
          <p class="fnt-size12px text-medium-grey">
            <span>{{speaker?.qualification}}</span>.<span>{{speaker?.speciality_name }}</span></p>
        </div>

        <span class="col-md-3 text-center  fnt-size14px   float-left mt-2 mt-md-0">
          <div class="border pt-2 pb-2 pl-3 pr-3 rounded cursor-pointer text-medium-grey">
            <svg viewBox="0 0 16 16" width="20px">
              <defs>
                <style>
                  .cls-shre-card {
                    fill: #a09fa0;
                  }
                </style>
              </defs>
              <g data-name="Layer 3" id="Layer_3">
                <path class="cls-shre-card" d="M9.5,13.2V9.92C5.33,9.92,2.58,11.2.5,14c.84-4,3.16-8,9-8.8V2l6,5.59Z">
                </path>
              </g>
            </svg> {{mls?.languageText?.webinar?.key4}}<span *ngIf="mls?.is_lskey_display==1">(webinar.key4)</span>
          </div>
        </span>
      </div>
    </div>
  </div>
</div>